import { createFileRoute } from "@tanstack/react-router";
import TmsTherapyGoogle from "@/pages/TmsTherapyGoogle";
export const Route = createFileRoute("/services/tms-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "TMS Therapy in Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "FDA-cleared TMS therapy for treatment-resistant depression in Coral Springs, FL. Non-invasive, covered by insurance. Check your eligibility in two minutes.",
        },
        {
          property: "og:title",
          content: "TMS Therapy in Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "FDA-cleared TMS therapy for treatment-resistant depression in Coral Springs, FL. Non-invasive, covered by insurance. Check your eligibility in two minutes.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/tms-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/tms-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsTherapyGoogle />;
}
